import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { RevvForm, CustomSelect } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";
import { DateOptions } from "../../../../constants/customDynamicMeta";
// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

class DateField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFieldValues: this._getDataForPrepopulate(props),
    };
  }

  componentDidMount() {
    this.props.setFlagForDefault(true);
  }

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.DATE),
    );
    if (propsData.meta && propsData.meta) {
      returnData = {
        format: { id: propsData.meta.format, name: propsData.meta.format },
      };
    }
    return returnData;
  };

  render() {
    const { dateFieldValues } = this.state;
    return (
      <React.Fragment>
        {
          <RevvForm
            initialFormValue={dateFieldValues}
            customFieldName="DATE"
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChangeByName,
                // handleBlur,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              console.debug("allInAll", allInAll);
              if (Object.keys(values.format).length > 0) {
                const data = {
                  format: values.format.name,
                };
                this.props.metaValidStatus(true);
                this.props.setMetaFieldValues(data);
              } else {
                this.props.metaValidStatus(false);
                this.props.setMetaFieldValues({});
              }
              return (
                <React.Fragment>
                  <span className="revvform-label">
                    Date format
                    <span className="requiredwitherr-input">*</span>
                  </span>
                  <CustomSelect
                    id="format"
                    name="format"
                    getOptionLabel={({ name }) => name}
                    options={DateOptions}
                    value={values.format}
                    _handleChangeInSelect={value =>
                      handleChangeByName(value, "format")
                    }
                    required
                  />
                </React.Fragment>
              );
            }}
          />
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DateField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/DateField.js